import { render, staticRenderFns } from "./ImagesList.vue?vue&type=template&id=460ee95d&"
import script from "./ImagesList.vue?vue&type=script&lang=js&"
export * from "./ImagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports